module.exports = __webpack_public_path__ + "img/login_bg.2e868d7a.png";